import getConfig from 'next/config';

import { isServer } from '@src/utils';

export const getMicrocreditsRequestUrl = (path: string) =>
    isServer
        ? `${process.env.MICROCREDITS}/v1/public/microCredit${path}`
        : `${getConfig().publicRuntimeConfig.publicUrl}/v1/microCredit${path}`;
